import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SignatureModels } from '../../../../models/signature.models';
import { SignatureApiService } from './api/signature-api.service';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  constructor(private api: SignatureApiService) {}

  createBrokerContractTransaction(
    modeEnvoi: SignatureModels.SendModeEnum,
  ): Observable<SignatureModels.SignatureInfo> {
    return this.api.createBrokerContractTransaction({
      modeEnvoi: modeEnvoi,
    });
  }

  signDocument(signInfo: SignatureModels.SignatureInfo) {
    return this.api.signDocument({
      code: signInfo.code,
      signatureId: signInfo.signatureId,
      transactionId: signInfo.transactionId,
    });
  }

  getRecap(): Observable<SignatureModels.Recap> {
    return this.api.getRecap();
  }

  goSignSignatureOrder(
    token: string,
  ): Observable<SignatureModels.StartSignatureResponse> {
    return this.api.postStartSignatureOrderTransaction(token);
  }

  getSignatureTransaction(id: string) {
    return this.api.getSignatureTransaction(id);
  }

  getSignatureOrderByToken(
    token: string,
  ): Observable<SignatureModels.SignatureOrderDetails> {
    return this.api.getSignatureOrderByToken(token);
  }
}
